module.exports = __webpack_public_path__ + "static/media/image_61.33c3be06.png";